import { render, staticRenderFns } from "./CircuitoEtapasPage.vue?vue&type=template&id=07a39031"
import script from "./CircuitoEtapasPage.vue?vue&type=script&lang=js"
export * from "./CircuitoEtapasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports